import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import AdminRoute from "./components/AdminRoute";
import AdminAISourcing from "./pages/AdminAISourcing";
import AdminImport from "./pages/AdminImport";
import AdminContentGenerator from "./pages/AdminContentGenerator";
import AdminLogin from "./pages/AdminLogin";

const About = lazy(() => import("./pages/About"));
const HowItWorksPage = lazy(() => import("./pages/HowItWorksPage"));
const ForFounders = lazy(() => import("./pages/ForFounders"));
const ForInvestors = lazy(() => import("./pages/ForInvestors"));
const Security = lazy(() => import("./pages/Security"));

const Contact = lazy(() => import("./pages/Contact"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const Cookies = lazy(() => import("./pages/Cookies"));
const FundraisingStatistics = lazy(() => import("./pages/FundraisingStatistics"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-background" />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/for-founders" element={<ForFounders />} />
            <Route path="/for-investors" element={<ForInvestors />} />
            <Route path="/security" element={<Security />} />
            
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/fundraising-statistics" element={<FundraisingStatistics />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            {/* Admin-only internal routes */}
            <Route
              path="/admin/ai-sourcing"
              element={
                <AdminRoute>
                  <AdminAISourcing />
                </AdminRoute>
              }
            />
            <Route path="/admin/import" element={<AdminRoute><AdminImport /></AdminRoute>} />
            <Route path="/admin/content-generator" element={<AdminRoute><AdminContentGenerator /></AdminRoute>} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
